import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import adminProfile from './../assets/adminprofile.webp';
import { BASE_URL } from "../services/api";

const adminemail = sessionStorage.getItem("email");
const adminImage = sessionStorage.getItem("profileImage");

const TopBar = ({ searchPlaceholder, onSearchChange, hideSearch = false }) => {
  // ✅ Handle full or partial URLs safely
  const getProfileImage = () => {
    if (!adminImage) return adminProfile;
    if (adminImage.startsWith("http")) return adminImage; // already a full URL
    return `${BASE_URL}${adminImage}`; // relative path
  };

  return (
    <div className="flex justify-between items-center w-full px-5 pt-16 md:pt-4">
      {/* Search bar - only visible if hideSearch is false */}
      {!hideSearch && (
        <div
          className="flex items-center bg-secondary py-1 w-[50%] rounded-2xl shadow-lg ml-16"
          style={{ backgroundColor: "#2C2E2D" }}
        >
          <SearchOutlined className="text-white/50 ml-6 mr-2" />
          <Input
            placeholder={searchPlaceholder}
            onChange={onSearchChange}
            className="bg-secondary text-white/50 placeholder-white/50 border-0 mr-4 outline-none text-lg focus:ring-0 mt-2"
            style={{
              backgroundColor: "#2C2E2D",
              paddingLeft: "1rem",
            }}
          />
        </div>
      )}

      {/* Admin info */}
      <div className="flex items-center ml-auto">
        <div className="mr-4 text-right">
          <div className="text-white font-medium">{adminemail}</div>
          <div className="text-white/50">Admin</div>
        </div>
        <div className="w-12 h-12 border-2 border-accent-green rounded-full overflow-hidden">
          <img
            src={getProfileImage()}
            alt="Admin"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default TopBar;
